import { withStyles } from '@material-ui/core';
import { Linked } from '@type-r/react';
import * as React from 'react';

export const BaseCheckbox = withStyles({
    root: {
        display: 'inline-flex',
        marginBottom: 'unset',
        marginRight : ( props : any ) => props.marginRight || 8,
    },

    label: {
        color: '#899095',
        fontSize: 9,
        fontWeight: 600,
        padding: 7,
        marginTop: 'auto',
        marginBottom: 'auto',
    },

    checkbox: {
        height: 20,
        width: 20,
        borderRadius : 2,
        borderWidth: 1,
        zIndex: 2,
        margin: 8,
        backgroundColor: 'white',
        borderColor: '#CED7DD',
        borderStyle: 'solid',
        alignSelf: 'center',
        cursor: 'pointer',
        '& input' : {
            display : 'none'
        },

        '& div' : {
            width: 10,
            height: 7,
            margin: '4px 3px 3px 4px',
            transform: 'rotate(-45deg)',
            borderColor: 'black',
            borderStyle: 'solid',
            borderWidth: '0 0 1px 1px',
            visibility: 'hidden'
        },

        '& .selected' : {
            visibility: "visible"
        }
    }
})(
    ({ $checked, classes, label, checked, readOnly } : {
        $checked? : Linked<boolean>,
        classes? : any,
        label? : string,
        checked? : boolean,
        readOnly? : boolean,
        marginRight? : string | number
    } ) =>
        <label
            className={classes.root}
            onClick={ e => {
                e.stopPropagation();
                if ($checked && !readOnly) {
                    $checked.set( !$checked.value );
                }
            }}
        >
            <div className={classes.checkbox}>
                <div className={
                    $checked ?
                        $checked.value ? 'selected' : ''
                    : checked ? 'selected' : ''
                }/>
            </div>
            { label ? <span className={classes.label}>{label}</span> : null }
        </label>
)
